// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Liff from "../liff/Liff.bs.js";
import * as React from "react";
import * as Layout from "../Layout.bs.js";
import * as Loading from "../components/Loading.bs.js";
import * as Promotion from "../components/Promotion.bs.js";
import * as HookProfile from "../hooks/HookProfile.bs.js";
import * as ProfileCoupons from "./ProfileCoupons.bs.js";
import * as ProfileReducer from "./ProfileReducer.bs.js";

function ProfileRegisterSuccessPage$Component(Props) {
  var coupons = Props.coupons;
  return React.createElement(Layout.LogoWithButton.make, {
              children: React.createElement("div", {
                    className: "flex flex-col items-center space-y-2"
                  }, React.createElement("div", {
                        className: "flex flex-col items-center"
                      }, React.createElement("div", {
                            className: "text-2xl font-heading"
                          }, "ขอบคุณสำหรับการลงทะเบียน")), React.createElement("div", {
                        className: "flex flex-col pb-4 w-full items-center"
                      }, React.createElement("div", {
                            className: "text-xl whitespace-pre-line text-center pb-8"
                          }, "พิเศษ! รับ Code ส่วนลด 10%\n            ลดสูงสุด 300 บาท (ไม่มีขั้นต่ำ)"), React.createElement(ProfileCoupons.make, {
                            coupons: coupons
                          })), React.createElement(Promotion.TextExpire.make, {
                        className: "pt-1",
                        expire: "31/07/2565"
                      }), React.createElement(Promotion.TextCloseRemark.make, {})),
              button_label: "ปิด",
              button_onClick: (function (param) {
                  return Liff.closeWindow(undefined);
                })
            });
}

var Component = {
  make: ProfileRegisterSuccessPage$Component
};

function ProfileRegisterSuccessPage(Props) {
  var liff = React.useContext(Liff.context);
  var state = HookProfile.useProfile(liff.access_token);
  if (typeof state === "number") {
    if (state === /* Request */0) {
      return React.createElement(Layout.Default.make, {
                  children: React.createElement("div", {
                        className: ""
                      }, React.createElement(Loading.make, {}))
                });
    } else {
      return React.createElement(Layout.$$Error.make, {});
    }
  }
  if (state.TAG !== /* SuccessRegisterdProfile */1) {
    return React.createElement(Layout.$$Error.make, {});
  }
  var coupons = ProfileReducer.getCoupons(state._0);
  return React.createElement(ProfileRegisterSuccessPage$Component, {
              coupons: coupons
            });
}

var make = ProfileRegisterSuccessPage;

export {
  Component ,
  make ,
  
}
/* Liff Not a pure module */
